import { Box } from "@mui/material";

import { theme } from "../../mui-customs/Theme";
import Typography from "../Typography";

interface ServicesDisplayTagProps {
  value: string;
}
const ServicesDisplayTag = ({ value }: ServicesDisplayTagProps) => {
  return (
    <Box
      sx={{
        border: `1px solid ${theme.brand1[500]}`,
        borderRadius: "6px",
        backgroundColor: theme.brand1[50],
        padding: 1,
      }}
    >
      <Typography variant="small5" sx={{ color: theme.brand1[500] }}>
        {value}
      </Typography>
    </Box>
  );
};

export default ServicesDisplayTag;
